// extracted by mini-css-extract-plugin
export var box = "_2d-2";
export var checkboxControl = "_2d-0";
export var checkboxRow = "_2d-a";
export var checked = "_2d-3";
export var descriptionSpacer = "_2d-c";
export var disabled = "_2d-4";
export var icon = "_2d-8";
export var input = "_2d-1";
export var labelSpacer = "_2d-b";
export var large = "_2d-7";
export var medium = "_2d-6";
export var small = "_2d-5";
export var text = "_2d-9";